<template>
  <div class="app-container-v2 table-container-v2 has-footer-bar">
    <div class="title-box">
      <div class="title-left">
        <span class="title-text">{{ title }}</span>
      </div>
      <div class="title-right">
        <div class="title-right-item">
          <select-cus @change="cusChange"></select-cus>
        </div>
        <div class="title-right-item ml16">
          <span class="font-14 color-3">{{ $t('salaryRange') }}：</span>
          <div class="date-picker-v2">
            <el-date-picker v-model="wageMonthRange" type="monthrange" format="yyyy-MM" value-format="yyyy-MM" :range-separator="$t('rangeSeparator')" start-placeholder="工资开始年月" end-placeholder="工资结束年月" prefix-icon="none" :clearable="false" :picker-options="wagePickerOptions" @change="getData"></el-date-picker>
            <img src="@/assets/img/v2/common/date.png" class="date-picker-icon" />
          </div>
        </div>
        <div class="title-right-item ml16" v-if="isCompare">
          <span class="font-14 color-3">{{ $t('comparisonRange') }}：</span>
          <div class="date-picker-v2">
            <el-date-picker v-model="differenceMonthRange" type="monthrange" format="yyyy-MM" value-format="yyyy-MM" :range-separator="$t('rangeSeparator')" :start-placeholder="$t('startYearMonth')" :end-placeholder="$t('endYearMonth')" prefix-icon="none" :clearable="false" :picker-options="differencePickerOptions" @change="getData"></el-date-picker>
            <img src="@/assets/img/v2/common/date.png" class="date-picker-icon" />
          </div>
        </div>
        <el-button plain class="button-v2 ml16" @click="showItemModal">{{ $t('displayItemConfiguration') }}</el-button>
        <el-button type="primary" class="button-v2" :loading="submitLoading" @click="exportExcel">{{ $t('export') }}</el-button>
      </div>
    </div>

    <div class="table-body flex vertical" v-loading="loading">
      <air-table
          v-if="render"
          ref="airTable"
          class="table-v2"
          :show-checkbox="false"
          :show-seq="false"
          :show-operation="!isWageItemCompare"
          :columns="columns"
          :tree-config="{children: 'children'}"
          :data="tableData"
      >
        <template #operation="{ row }">
          <span v-if="row.statisticType !== '合计' && row.statisticType !== '合计平均'" class="text-button" @click="showDetailModal(row)">{{ $t('viewDetails') }}</span>
        </template>
      </air-table>

      <vxe-pager
          v-if="!isWageItemCompare"
          class="pager-v2"
          background
          :current-page.sync="queryParams.page"
          :page-size.sync="queryParams.limit"
          :total="total"
          :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'Sizes', 'Total']"
          @page-change="getData"
      ></vxe-pager>
    </div>

    <air-footer-bar>
      <el-button plain class="button-v2" @click="backToList">{{ $t('back') }}</el-button>
    </air-footer-bar>

    <el-dialog class="modal-v2" :title="$t('displayItemConfiguration')" :visible.sync="itemModalShow" :close-on-click-modal="false" width="700px" append-to-body>
      <div class="flex center mt20 mb20">
        <el-transfer
            class="transfer-v2"
            :titles="[$t('hiddenItems'), $t('displayItems')]"
            filterable
            :filter-placeholder="$t('search')"
            v-model="checkedItemCodeList"
            :data="allItemCodeList">
        </el-transfer>
      </div>

      <div slot="footer" class="w100 flex jbetween acenter">
        <el-button plain class="button-v2" @click="itemModalShow = false">{{ $t('cancel') }}</el-button>
        <div class="flex acenter">
          <el-button type="primary" class="button-v2" :loading="submitLoading" @click="saveShowItem">{{ $t('save') }}</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog class="modal-v2" :title="$t('viewDetails')" :visible.sync="detailModalShow" :close-on-click-modal="false" width="1050px" append-to-body>
      <div class="w100 flex center mt20 mb20">
        <air-table
          :key="detailTableKey"
          ref="airTable"
          class="table-v2"
          style="width: 1000px; height: 500px;"
          :show-checkbox="false"
          :show-operation="false"
          :columns="detailColumns"
          :data="detailTableData"
        ></air-table>
      </div>

      <div slot="footer" class="w100 flex jend acenter">
        <el-button plain class="button-v2" @click="detailModalShow = false">{{ $t('close') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as apiCustomReport from '@/api/v2/stats/data-center/custom-report'
import SelectCus from '@/views/v2/stats/data-center/components/Common/SelectCus';
export default {
  name: 'CustomReportDetail',
  components: {
    SelectCus
  },
  data() {
    return {
      render: false,
      title: '',
      type: '',
      isCompare: false,
      isWageItemCompare: false,
      compareTypeList: ['92750003', '92750004', '92750005'],
      loading: true,
      queryParams: {
        reportId: undefined,
        wageStartMonth: undefined,
        wageEndMonth: undefined,
        differenceStartMonth: undefined,
        differenceEndMonth: undefined,
        page: 1,
        limit: 20
      },
      total: 0,
      originData: {},
      wagePickDate: {},
      wagePickerOptions: {
        onPick: this.onWagePickDate,
        disabledDate: this.disabledWageDate
      },
      wageMonthRange: [],  // 当前工资月份区间
      differencePickDate: {},
      differencePickerOptions: {
        onPick: this.onDifferencePickDate,
        disabledDate: this.disabledDifferenceDate
      },
      differenceMonthRange: [],  // 对比工资月份区间
      columns: [],
      tableData: [],
      itemModalShow: false,
      allItemList: [],
      allItemCodeList: [],
      checkedItemCodeList: [],
      submitLoading: false,
      detailModalShow: false,
      detailColumns: [],
      detailTableData: [],
      detailTableKey: 1,
      cusIds: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.title = this.$route.query.title
      this.queryParams.reportId = this.$route.query.id
      this.wageMonthRange = this.$last12Months()
      this.type = this.$route.query.type
      // 是否为对比表
      this.isCompare = this.compareTypeList.includes(this.type)
      if (this.isCompare) {
        this.differenceMonthRange = this.$last12Months()
      }
      // 是否为薪资项对比表
      this.isWageItemCompare = this.type === '92750005'
      this.getData()
    },
    getData() {
      this.render = false
      this.loading = true
      this.queryParams.wageStartMonth = this.wageMonthRange[0]
      this.queryParams.wageEndMonth = this.wageMonthRange[1]
      this.queryParams.differenceStartMonth = this.differenceMonthRange[0]
      this.queryParams.differenceEndMonth = this.differenceMonthRange[1]
      this.queryParams.cusIds = this.cusIds;
      apiCustomReport.getDetail(this.queryParams).then(res => {
        this.originData = res.data.data
        if (this.isWageItemCompare) {
          this.handleWageItemCompareTable(res.data.data)
        } else {
          this.handleTable(res.data.data)
        }
        this.render = true
        this.loading = false
      })
    },
    handleTable(data) {
      this.total = data.data.page.total
      let columns = [{
        title: data.statisticTypes.map(item => item.codeItemName).join(' - '),
        field: 'statisticType',
        minWidth: 80 * data.statisticTypes.length,
        headerAlign: 'center',
        fixed: 'left',
        treeNode: true
      }]
      let compareSuffix = this.type === '92750003' ? 'TotalPart' : 'AvgPart'
      // 如果是对比表
      if (this.isCompare) {
        for (let item of data.columnNames) {
          if (item.columnCode === 'wageMonth') continue
          columns.push({
            title: item.itemName,
            align: 'center',
            isGroup: true,
            children: [
              {
                title: this.wageMonthRange.join('~'),
                field: `${item.columnCode}_wage${compareSuffix}`,
                minWidth: 150,
                align: 'right',
                money: true
              },
              {
                title: this.differenceMonthRange.join('~'),
                field: `${item.columnCode}_difference${compareSuffix}`,
                minWidth: 150,
                align: 'right',
                money: true
              },
              {
                title: '差异',
                field: `${item.columnCode}_difference`,
                minWidth: 80,
                align: 'right',
                money: true
              }
            ]
          })
        }
      } else {
        for (let item of data.columnNames) {
          if (item.columnCode === 'wageMonth') continue
          columns.push({
            title: item.itemName,
            field: item.columnCode,
            minWidth: 100,
            align: 'right',
            money: true
          })
        }
      }
      this.columns = columns
      this.tableData = this.handleTreeData(data.data.resultList)
      // 表尾合计行
      if (this.tableData.length) {
        let sumSuffix = this.type === '92750001' || this.type === '92750004' ? '平均' : ''
        // 如果是对比表
        if (this.isCompare) {
          let compareSum = { statisticType: `合计${sumSuffix}` }
          for (let sumKey in data.data.sum) {
            compareSum[`${sumKey}_wage${compareSuffix}`] = data.data.sum[sumKey].wagePartSum
            compareSum[`${sumKey}_difference${compareSuffix}`] = data.data.sum[sumKey].differencePartSum
            compareSum[`${sumKey}_difference`] = data.data.sum[sumKey].differenceSum
          }
          this.tableData.push(compareSum)
        } else {
          this.tableData.push({ statisticType: `合计${sumSuffix}`, ...data.data.sum })
        }
      }
    },
    handleTreeData(treeData) {
      let dataList = []
      for (let key in treeData) {
        let rowData = {}
        // 数据的key即为当前层级统计口径的值
        rowData.statisticType = key
        rowData.detailList = treeData[key].detailList
        if (treeData[key].childList && Object.keys(treeData[key].childList).length) {
          // 递归
          rowData.children = this.handleTreeData(treeData[key].childList)
        }
        // 如果是对比表
        if (this.isCompare) {
          for (let computedDataKey in treeData[key].computedData) {
            for (let compareKey in treeData[key].computedData[computedDataKey]) {
              rowData[`${computedDataKey}_${compareKey.split('_')[0]}`] = treeData[key].computedData[computedDataKey][compareKey]
            }
          }
          dataList.push(rowData)
        } else {
          dataList.push({ ...rowData, ...treeData[key].computedData })
        }
      }
      return dataList
    },
    handleWageItemCompareTable(data) {
      this.columns = [
        {
          title: '薪资项',
          field: 'wageItem',
          minWidth: 150,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '总值',
          align: 'center',
          isGroup: true,
          children: [
            {
              title: this.wageMonthRange.join('~'),
              field: `total1-${this.wageMonthRange.join('-')}`,
              minWidth: 150,
              align: 'right',
              money: true
            },
            {
              title: this.differenceMonthRange.join('~'),
              field: `total2-${this.differenceMonthRange.join('-')}`,
              minWidth: 150,
              align: 'right',
              money: true
            },
            {
              title: '差异',
              field: `total-difference`,
              minWidth: 80,
              align: 'right',
              money: true
            }
          ]
        },
        {
          title: '均值',
          align: 'center',
          isGroup: true,
          children: [
            {
              title: this.wageMonthRange.join('~'),
              field: `avg1-${this.wageMonthRange.join('-')}`,
              minWidth: 150,
              align: 'right',
              money: true
            },
            {
              title: this.differenceMonthRange.join('~'),
              field: `avg2-${this.differenceMonthRange.join('-')}`,
              minWidth: 150,
              align: 'right',
              money: true
            },
            {
              title: '差异',
              field: `avg-difference`,
              minWidth: 80,
              align: 'right',
              money: true
            }
          ]
        }
      ]
      this.tableData = data.data
    },
    showDetailModal(row) {
      this.detailTableData = row.detailList
      this.detailColumns = this.originData.columnNames.map(item => {
        return {
          title: item.itemName,
          field: item.columnCode,
          minWidth: 100,
          align: 'right',
          money: item.columnCode !== 'wageMonth'
        }
      })
      this.detailTableKey++
      this.detailModalShow = true
    },
    async showItemModal() {
      await this.getShowItem()
      this.itemModalShow = true
    },
    getShowItem() {
      return apiCustomReport.getShowItem(this.queryParams).then(res => {
        this.allItemList = res.data.data.all
        this.allItemCodeList = res.data.data.all.map(item => {
          return {
            key: item.columnCode,
            label: item.itemName
          }
        })
        this.checkedItemCodeList = res.data.data.checked.map(item => item.columnCode)
      })
    },
    saveShowItem() {
      if (!this.checkedItemCodeList.length) {
        this.$msgError('显示项目不能为空')
        return
      }
      this.submitLoading = true
      const showItemList = this.allItemList.filter(item => this.checkedItemCodeList.includes(item.columnCode))
      apiCustomReport.editShowItem({
        reportId: this.queryParams.reportId,
        dataList: showItemList
      }).then(res => {
        this.$msgSuccess('保存成功')
        this.getData()
        this.itemModalShow = false
      }).finally(() => this.submitLoading = false)
    },
    exportExcel() {
      this.submitLoading = true
      apiCustomReport.exportAvg(this.queryParams).then(res => {
        this.$downloadFile(res)
      }).finally(() => this.submitLoading = false)
    },
    backToList() {
      this.$setStore('dataCenter_currentTab', '自定义报表')
      this.$go('/v2/stats/data-center')
    },
    backToStep2() {
      this.$setStore('dataCenter_currentTab', '自定义报表')
      this.$go('/v2/stats/data-center', { reportModalStep: 2, reportId: this.queryParams.reportId })
    },
    onWagePickDate(pickDate) {
      this.wagePickDate = pickDate
    },
    disabledWageDate(date) {
      const { minDate, maxDate } = this.wagePickDate
      if (minDate && !maxDate) {
        // 限制最大可选范围为12个月
        return this.$day(date).isBefore(this.$day(minDate).subtract(1, 'y').add(1, 'M'))
            || this.$day(date).isAfter(this.$day(minDate).add(1, 'y').subtract(1, 'M'))
      }
    },
    onDifferencePickDate(pickDate) {
      this.differencePickDate = pickDate
    },
    disabledDifferenceDate(date) {
      const { minDate, maxDate } = this.differencePickDate
      if (minDate && !maxDate) {
        // 限制最大可选范围为12个月
        return this.$day(date).isBefore(this.$day(minDate).subtract(1, 'y').add(1, 'M'))
            || this.$day(date).isAfter(this.$day(minDate).add(1, 'y').subtract(1, 'M'))
      }
    },
    // 客户筛选change事件
    cusChange({ data, checkedLabels, checkedValues }) {
      this.cusIds = checkedValues;
      this.getData();
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/air/assets/css/main.scss";
</style>
